import PropTypes from 'prop-types';
import React from 'react';
import { Collapse, Button, Spinner } from 'reactstrap';
import Icon from '../../../common/containers/icon';
import FollowupAnalysisResults from './followupAnalysisResults';
const FollowupDetails = ({
  followup,
  followupId,
  hasAnalysis,
  isOpen,
  isRunning,
  pendingOperation: _pendingOperation = false,
  onRunInvestigation
}) => /*#__PURE__*/React.createElement(Collapse, {
  isOpen: isOpen
}, /*#__PURE__*/React.createElement("div", {
  className: "mt-3 ms-4 ps-2 border-start"
}, followup.reasoning && /*#__PURE__*/React.createElement("div", {
  className: "mb-3"
}, /*#__PURE__*/React.createElement("div", {
  className: "text-muted small"
}, "Reasoning"), /*#__PURE__*/React.createElement("div", {
  className: "fw-medium"
}, followup.reasoning)), !hasAnalysis && /*#__PURE__*/React.createElement("div", {
  className: "mb-3"
}, /*#__PURE__*/React.createElement(Button, {
  color: "primary",
  size: "sm",
  onClick: onRunInvestigation,
  disabled: isRunning || _pendingOperation
}, isRunning ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
  size: "sm",
  style: {
    marginRight: 6
  }
}), "Running...") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
  glyph: "wand-magic-sparkles",
  style: {
    marginRight: 6
  }
}), "Run Analysis"))), hasAnalysis && /*#__PURE__*/React.createElement(FollowupAnalysisResults, {
  followup: followup,
  followupId: followupId
})));
FollowupDetails.propTypes = {
  followup: PropTypes.shape({
    reasoning: PropTypes.string,
    analysis: PropTypes.shape({})
  }).isRequired,
  followupId: PropTypes.string.isRequired,
  hasAnalysis: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  isRunning: PropTypes.bool.isRequired,
  pendingOperation: PropTypes.bool,
  onRunInvestigation: PropTypes.func.isRequired
};
export default FollowupDetails;